export default "__VITE_ASSET__b6d528ec__"